import React, {useEffect, useState} from 'react'
import FlashCards from './FlashCards'
import io from "socket.io-client";
//import {IsLoggedContext} from '../Store'
import '../styles/styles.css'
import { Link } from 'react-router-dom'
import Timer from './Timer'
import { config } from '../server'
import '../styles/viewset.css'
import { useAuth0 } from '@auth0/auth0-react';
const address = config.url.API_URL


//let endPoint = "https://clusterfy.herokuapp.com";
let socket = io.connect("https://clusterfy.herokuapp.com");
//initial commit
const ViewSet = (props) => {
const [allStudies, setAllStudies]  = useState([])
const setName = props.match.params.viewSet
const [topicNames, setTopicNames] = useState([])
const [messages, setMessages] = useState(["Chat Help"]);
const [message] = useState("");
//const [isLogged] = useContext(IsLoggedContext)
const [toggleMessages] = useState(true)
const [startTimer, setStartTimer] = useState(false)
const { user, isAuthenticated, isLoading } = useAuth0();

const time = new Date();
time.setSeconds(time.getSeconds() + 1500);

useEffect(() => {
	fetch(address + '/api/getSets').then(res => res.json()).then(data => {
	// console.log(data)
	const data2 = data.allDocs
	setAllStudies(data.allDocs)
	let vals = []
	let vals2 = []
	let test = []
	for(let i = 0; i < data.allDocs.length; i++) {
		
		if(isAuthenticated) {
			if(data2[i].name !== user.nickname || data2[i].name === user.nickname){
				vals.push(data2[i].studyTitle)
				test.push({studyTitle: data2[i].studyTitle, names: data2[i].name})
				vals2.push(data2[i].topicName)
				}
		}
		else {
			vals.push(data2[i].studyTitle)
			test.push({studyTitle: data2[i].studyTitle, names: data2[i].name})
			vals2.push(data2[i].topicName)
		}
	}
	const unique2 = new Set(vals2)
	const newUnique2 = [...unique2]
	setTopicNames(newUnique2)
	});
}, [user, isAuthenticated]);


useEffect(() => {
	let newTopics = []
	for(let i = 0; i < allStudies.length; i++){
	if(allStudies[i].studyTitle === setName) {
		newTopics.push(allStudies[i].topicName)
	}
	}
	setTopicNames(newTopics)
	const getMessages = () => {
	socket.on("message", msg => {

		setMessages([...messages, msg]);
	});
};

socket.on('join')
	//createGame()
	//sendMsg()
	getMessages()

}, [allStudies, setName, messages, message])
	
/*const onClick = () => {
	if (message !== "") {
	// 
	socket.emit('join', {message: user + ": " + message, room: setName})
	setMessage("");
	} else {
	alert("Please Add A Message");
	}
};*/
/*const onChange = e => {
	setMessage(e.target.value);
};*/

/*const rightText = (text) => {
	const wordStyle = {
	overflowWrap: 'break-word',
	wordWrap: 'break-word',
	wordBreak: 'break-all',
	hyphens: 'auto',
}
	if(text === 'Chat Help'){
	return(
		<p className="has-text-danger">
		{text}
		</p>
	)
	} else {
	return(
	<div className="messageDisplay">
		<p style={wordStyle}>
		{text}
		</p>
	</div>
	)
	}
}*/


/*const handleSubmit = (event) => {
	event.preventDefault()
}*/

const startClock = () => {
	setStartTimer(!startTimer)
}

if(isLoading) {
	return (
		<div>
			Loading...
		</div>
	)
}

return (
		<div>



				<div className="heroContainer">
					<h1>{setName}</h1>
				</div>

				<div className="subNav">
					<div className="subNavBtn" onClick={() => startClock()}>Study Timer</div>
					<Link className="subNavBtn" to={`/${setName}/draw`}>Doodle Tool</Link>
				</div>

				<div>
					{startTimer && toggleMessages && <Timer expiryTimestamp={time} />}
				</div>

			



			


			<div style={{paddingTop: '5%'}}>
				{topicNames.map((topic,i) => (
				<div key={i} className="level-item">
					<div className="column is-6" style={{paddingTop: '2.5%'}} key={i}>
					<ul key={i}>
						<li key={i}>
						<div key={i}>
						<div key={i}>
						<FlashCards key={i} setNames={setName} topic={topic} allStudies={allStudies}/>
						</div>
						</div>
						</li>
					</ul>
					</div>
				</div>
				))}
			</div>
		</div>
	)
}




export default ViewSet